// utils.js
/**
 * Φιλτράρει άρθρα βάσει της γλώσσας τους.
 * @param {Array} articles - Λίστα άρθρων.
 * @param {string} language - Η γλώσσα που θέλουμε να εμφανίσουμε ('el', 'en', κλπ).
 * @returns {Array} - Φιλτραρισμένα άρθρα.
 */
export const filterByLanguage = (articles, language = 'el') => {
  if (!articles || !Array.isArray(articles)) return [];
  return articles.filter(article => article.language === language);
};
